import CostCalculationTable from './CostCalculationTable';

export default CostCalculationTable;
